import { createSlice } from "@reduxjs/toolkit"

type GridView = 'single' | 'double'

const gridViewSlice = createSlice({
  name: 'gridView',
  initialState: { view: 'single' as GridView },
  reducers: {
    toggleGridView: (state) => {
      state.view = state.view === 'single' ? 'double' : 'single'
    }
  }
})

export const { toggleGridView } = gridViewSlice.actions
export const selectGridView = (state: { gridView: { view: GridView } }) => state.gridView.view
export default gridViewSlice.reducer
